import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FrequencyViewChartComponent} from './frequency-view-chart/frequency-view-chart.component';
import {
  FrequencyViewChartContainerComponent
} from './frequency-view-chart-container/frequency-view-chart-container.component';
import {
  FrequencyViewChartPopoverContainerComponent
} from './frequency-view-chart-popover/frequency-view-chart-popover-container/frequency-view-chart-popover-container.component';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {
  FrequencyViewChartSplatPopoverComponent
} from './frequency-view-chart-popover/frequency-view-chart-splat-popover/frequency-view-chart-splat-popover.component';
import {FormsModule} from '@angular/forms';
import {
  FrequencyViewChartFilterLinesComponent
} from './frequency-view-chart-filters/frequency-view-chart-filter-lines/frequency-view-chart-filter-lines.component';
import {
  FrequencyViewChartFilterMoleculesComponent
} from './frequency-view-chart-filters/frequency-view-chart-filter-molecules/frequency-view-chart-filter-molecules.component';
import {
  FrequencyViewChartFilterRedshiftComponent
} from './frequency-view-chart-filters/frequency-view-chart-filter-redshift/frequency-view-chart-filter-redshift.component';
import {
  FrequencyViewChartFiltersContainerComponent
} from './frequency-view-chart-filters/frequency-view-chart-filters-container/frequency-view-chart-filters-container.component';
import {AsaxCommonModule} from 'asax-common';
import { FrequencyViewChartResetBoundariesButton } from './frequency-view-chart-reset-boundaries-button/frequency-view-chart-reset-boundaries-button.componenet';


@NgModule({
  declarations: [
    FrequencyViewChartComponent,
    FrequencyViewChartContainerComponent,
    FrequencyViewChartPopoverContainerComponent,
    FrequencyViewChartSplatPopoverComponent,
    FrequencyViewChartFilterLinesComponent,
    FrequencyViewChartFilterMoleculesComponent,
    FrequencyViewChartFilterRedshiftComponent,
    FrequencyViewChartFiltersContainerComponent,
    FrequencyViewChartResetBoundariesButton
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    AsaxCommonModule
  ],
  exports: [
    FrequencyViewChartContainerComponent
  ]
})
export class FrequencyViewChartModule {
}
